let Calls = {
    apiBaseUri: "api/v1/",
    apiToolsBaseUri: "api/v1/tools/",
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async callForm(url, bodyFiles, skipJson=false){
      return await fetch(url, {
        method: "POST",
        body: bodyFiles,
        headers: {
          "Accept": "application/json",
          Authorization: "Bearer "+sessionStorage.getItem("token")
        }
      }).then(resp=>{
        if(resp.ok&&!skipJson){
          return resp.json();
        }else if(resp.ok){
          return resp;
        }else if(resp.status===403||resp.status===401){
          console.error("bez oprávnění");
          sessionStorage.removeItem("token");
          sessionStorage.setItem("msg", "Vaše relace vypršela, je třeba se opět přihlásit.");
          localStorage.removeItem("kwetoken");
          window.location.href = window.location;
          throw new Error("403")
        }else{
          throw new Error("Chyba!")
        }
      });
    },
    async call(method, url, bodyToJson, skipJson=false) {
      return await fetch(url, {
        method: method,
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer "+sessionStorage.getItem("token")
        },
        body: JSON.stringify(bodyToJson)
      }).then(resp=>{
        if(resp.ok&&!skipJson){
          return resp.json();
        }else if(resp.ok){
          return resp;
        }else if(resp.status===403||resp.status===401){
          console.error("bez oprávnění");
          sessionStorage.removeItem("token");
          sessionStorage.setItem("msg", "Vaše relace vypršela, je třeba se opět přihlásit.");
          localStorage.removeItem("kwetoken");
          window.location.href = window.location;
          throw new Error("403")
        }else{
          throw new Error("Chyba!")
        }
      });
    },
    async callOutter(method, url, body, skipJson=false, headers={}) {
      let headersArr = {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8",
      };
      if(typeof headers === "object"&&headers!==null){
        headersArr = {...headersArr, ...headers};
      }
      return await fetch(url, {
        method: method,
        headers: headersArr,
        body: body,
        mode: "cors"
      }).then(resp=>{
        if(resp.ok&&!skipJson){
          return resp.json();
        }else if(resp.ok){
          return resp;
        }else{
          console.log(resp)
          throw new Error("Chyba!")
        }
      });
    },
  
    getUri: function(useCase) {
      return (
          process.env.REACT_APP_URL + useCase
      );
    },
    getApiUri: function(useCase, params) {
      var url = new URL(process.env.REACT_APP_API+useCase);
      if(params){
        url.search = new URLSearchParams(params).toString();
      }
      return (
          url
      );
    },
    async postLogin(username="",password=""){
      let commandUri = this.getApiUri(this.apiBaseUri+"login");
      return await Calls.call("POST", commandUri, {username: username, password: password});
    },
    async postToken(refreshToken){
      let commandUri = this.getApiUri(this.apiBaseUri+"refresh-token");
      return await Calls.call("POST", commandUri, {refreshToken: refreshToken});
    },
    async postRegister(userDetail){
      //přijímá IUser
      let commandUri = this.getApiUri(this.apiBaseUri+"register");
      return await Calls.call("POST", commandUri, {email: userDetail.email, firstName: userDetail.firstName, surname: userDetail.surname, accountType: userDetail.accountType, isNewsletterSubscribed: userDetail.isNewsletterSubscribed});
    },
    async patchRegister(token, password){
      let commandUri = this.getApiUri(this.apiBaseUri+"register");
      return await Calls.call("PATCH", commandUri, {
        "verificationHash": token,
        "password": password
      });
    },
    async postLogout(){
      let commandUri = this.getApiUri(this.apiBaseUri+"logout");
      return await Calls.call("POST", commandUri, undefined, true);
    },
    async getTemplate(templateName) {
      let commandUri = this.getUri("templates/"+templateName+".html");
      return await Calls.call("get", commandUri);
    },
    async callLogin(msg) {
      let commandUri = this.getUri("api/login.php");
      return await Calls.call("post", commandUri, msg);
    },
    async callSetData(msg) {
      let commandUri = this.getUri("api/setData.php");
      return await Calls.call("post", commandUri, msg);
    },
    async getData(msg) {
      let commandUri = this.getUri("api/getData.php");
      return await Calls.call("post", commandUri, msg);
    },
    async getSovCount(){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/count");
      return await Calls.call("GET", commandUri);
    },
    async getSovList(page){
      var params = {page:page};
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov", params);
      return await Calls.call("GET", commandUri);
    },
    // async getSovDetail(id){
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/"+id);
    //   return await Calls.call("GET", commandUri);
    // },
    async getSovExport(id, fileExtension="csv", type="sov"){
      //searchVol -> /search-volume, sov-> /
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/"+id+"/export"+(type==="searchVol"?"/search-volume":""), {format: fileExtension});
      return await Calls.call("GET", commandUri, undefined, true);
    },
    // async postSovRun(body={}){
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/");
    //   return await Calls.call("POST", commandUri, body);
    // },
    // async getSovDetailGraphs(id, type){
    //   let getParams = {};
    //   if(type!==undefined){
    //     getParams.type = type;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/"+id+"/graphs", getParams);
    //   return await Calls.call("GET", commandUri);
    // },
    async getCgaCount(){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/count");
      return await Calls.call("GET", commandUri);
    },
    async getCgaList(page){
      var params = {page:page};
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga", params);
      return await Calls.call("GET", commandUri);
    },
    async getCgaDetail(id){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id);
      return await Calls.call("GET", commandUri);
    },
    // async getCgaExport(id, fileExtension="csv"){
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id+"/export", {format: fileExtension});
    //   return await Calls.call("GET", commandUri, undefined, true);
    // },
    // async getCgaDetailGraphs(id, type=undefined){
    //   let getParams = {};
    //   if(type!==undefined){
    //     getParams.type = type;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id+"/graphs", getParams);
    //   return await Calls.call("GET", commandUri);
    // },
    async getCgaDetailData({id, page, limit=10, filter=undefined, sortBy=undefined}){
      //TODO vrátit, až bude fungovat filtr na BE
      var params = {page:page, limit:limit};
      if(filter!==undefined){
        params.filter = filter;
      }
      if(sortBy!==undefined){
        params["sort_by"] = sortBy;
      }
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id+"/data-flow", params);
      // let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id+"/data");
      return await Calls.call("GET", commandUri);
    },
    // async getCgaDetailCount(id){
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id+"/data/count");
    //   return await Calls.call("GET", commandUri);
    // },
    async postCgaRun(body={}){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/");
      return await Calls.call("POST", commandUri, body);
    },
    async delCga(id){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"cga/"+id);
      return await Calls.call("DELETE", commandUri, undefined, true);
    },
    async delSov(id){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"sov/"+id);
      return await Calls.call("DELETE", commandUri, undefined, true);
    },
    async delProject(id){
      let commandUri = this.getApiUri(this.apiBaseUri+"project/"+id);
      return await Calls.call("DELETE", commandUri, undefined, true);
    },
    async postCgaUploadFiles(files = []){
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
      let commandUri = this.getApiUri("api/v1/uploads");
      return await Calls.callForm(commandUri, formData, false);
    },
    async postGsc(domain, accessToken, refreshToken, firstPeriodStart, firstPeriodEnd, secondPeriodStart, secondPeriodEnd, device){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"gsc/"+encodeURIComponent(domain), (device!==undefined&&device!=="ALL"?{device:device}:undefined));
      return await Calls.call("POST", commandUri, {token: accessToken, refreshToken: refreshToken, startPeriod: {startDate: firstPeriodStart, endDate: firstPeriodEnd}, endPeriod: {startDate: secondPeriodStart, endDate: secondPeriodEnd}});
    },
    // async postGscKws(domain, accessToken, refreshToken, firstPeriodStart, firstPeriodEnd, secondPeriodStart, secondPeriodEnd, page, orderBy=undefined, include=[], exclude=[], limit=10, device="ALL"){
    //   let filterData = {page: page, limit: limit};
    //   if(include.length>0){
    //     filterData.include = include;
    //   }
    //   if(device!==undefined&&device!=="ALL"){
    //     filterData.device = device;
    //   }
    //   if(exclude.length>0){
    //     filterData.exclude = exclude;
    //   }
    //   if(orderBy!==undefined){
    //     filterData.sortBy = orderBy;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"gsc/"+encodeURIComponent(domain)+"/kws", filterData);
    //   return await Calls.call("POST", commandUri, {token: accessToken, refreshToken: refreshToken, startPeriod: {startDate: firstPeriodStart, endDate: firstPeriodEnd}, endPeriod: {startDate: secondPeriodStart, endDate: secondPeriodEnd}});
    // },
    // async postGscTopInsights(domain, accessToken, refreshToken, firstPeriodStart, firstPeriodEnd, secondPeriodStart, secondPeriodEnd, include=[], exclude=[], limit=10, device="ALL"){
    //   let filterData = {limit:limit};
    //   if(device!==undefined&&device!=="ALL"){
    //     filterData.device = device;
    //   }
    //   if(include.length>0){
    //     filterData.include = include;
    //   }
    //   if(exclude.length>0){
    //     filterData.exclude = exclude;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"gsc/"+encodeURIComponent(domain)+"/top-insights", filterData);
    //   return await Calls.call("POST", commandUri, {token: accessToken, refreshToken: refreshToken, startPeriod: {startDate: firstPeriodStart, endDate: firstPeriodEnd}, endPeriod: {startDate: secondPeriodStart, endDate: secondPeriodEnd}});
    // },
    async postGscSearchAnalytics(domain, accessToken, refreshToken, firstPeriodStart, firstPeriodEnd, secondPeriodStart, secondPeriodEnd){
      let commandUri = this.getApiUri(this.apiToolsBaseUri+"gsc/search-analytics")+encodeURIComponent(domain);
      return await Calls.call("POST", commandUri, {token: accessToken, refreshToken: refreshToken, startDate: "2021-03-10",endDate: "2021-03-11"});
    },
    // async postGscGraph(domain, accessToken, refreshToken, firstPeriodStart, firstPeriodEnd, secondPeriodStart, secondPeriodEnd, device, include=[], exclude=[]){
    //   let filterData = {};
    //   if(include.length>0){
    //     filterData.include = include;
    //   }
    //   if(exclude.length>0){
    //     filterData.exclude = exclude;
    //   }
    //   if(device!==undefined&&device!=="ALL"){
    //     filterData.device = device;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"gsc/"+encodeURIComponent(domain)+"/graph", filterData);
    //   return await Calls.call("POST", commandUri, {"token": accessToken, "refreshToken": refreshToken, "startPeriod": {startDate: firstPeriodStart, endDate: firstPeriodEnd}, endPeriod: {startDate: secondPeriodStart, endDate: secondPeriodEnd}});
    // },
    // async gscqwOverview(domain, accessToken, startDate, endDate, isCount, include=[], exclude=[], device="ALL", page, limit){
    //   let filterData = (isCount?{"count":null}:{});
    //   filterData.page = page;
    //   filterData.limit = limit;
    //   if(include.length>0){
    //     filterData.include = include;
    //   }
    //   if(exclude.length>0){
    //     filterData.exclude = exclude;
    //   }
    //   if(device!==undefined&&device!=="ALL"){
    //     filterData.device = device;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"quick-win/"+encodeURIComponent(domain), filterData);
    //   return await Calls.call("POST", commandUri, {googleToken:{token: accessToken}, datePeriod: {startDate: startDate, endDate: endDate}});
    // },
    // async gscqwOptimiseQueries(domain, accessToken, startDate, endDate, isCount,include=[], exclude=[], page, limit, device="ALL"){
    //   let filterData = (isCount?{"count":null}:{});
    //   filterData.page = page;
    //   filterData.limit = limit;
    //   if(include.length>0){
    //     filterData.include = include;
    //   }
    //   if(exclude.length>0){
    //     filterData.exclude = exclude;
    //   }
    //   if(device!==undefined&&device!=="ALL"){
    //     filterData.device = device;
    //   }
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"quick-win/"+encodeURIComponent(domain)+"/optimise-queries", filterData);
    //   return await Calls.call("POST", commandUri, {googleToken:{token: accessToken}, datePeriod: {startDate: startDate, endDate: endDate}});
    // },
    // async gscqwGraphOportunities(domain, accessToken, startDate, endDate, positionLower=0, positionUpper=10, missedClicksLower=0, missedClicksUpper=10, device="ALL"){
    //   // positions and missed clics = 0-10 (lower - upper);
    //   let commandUri = this.getApiUri(this.apiToolsBaseUri+"quick-win/"+encodeURIComponent(domain)+"/graphs/ctr-opportunities", (device!==undefined&&device!=="ALL"?{device:device}:undefined));
    //   return await Calls.call("POST", commandUri, {googleToken:{token: accessToken}, datePeriod: {startDate: startDate, endDate: endDate}, "position": {"lower": positionLower,"upper": positionUpper},"missedClicks": {"lower": missedClicksLower,"upper": missedClicksUpper}});
    // },
    async getProjects(page){
      let commandUri = this.getApiUri(this.apiBaseUri+"project", {page:page});
      return await Calls.call("GET", commandUri);
    },
    async getProjectsCount(){
      let commandUri = this.getApiUri(this.apiBaseUri+"project/count");
      return await Calls.call("GET", commandUri);
    },
    async getProjectDetail(id){
      let commandUri = this.getApiUri(this.apiBaseUri+"project/"+id);
      return await Calls.call("GET", commandUri);
    },
    // async postProject(name, domain, location, competitors, refreshToken, keywords, thumbImagePath=null){
    //   let commandUri = this.getApiUri(this.apiBaseUri+"project");
    //   return await Calls.call("POST", commandUri, {name: name, domain: domain, location: location, googleToken: refreshToken, competitors: competitors, keywords: keywords, thumbImagePath: thumbImagePath});
    // },
    async gscDomainList(accessToken){
      const commandUri = "https://content-searchconsole.googleapis.com/webmasters/v3/sites";
      return await Calls.callOutter("GET", commandUri, null, false, {Authorization: "Bearer "+accessToken});
    },
    async getGoogleUserInfo(accessToken){
      const commandUri = "https://www.googleapis.com/oauth2/v1/userinfo";
      return await Calls.callOutter("GET", commandUri, null, false, {Authorization: "Bearer "+accessToken});
    },
    // async getLinkBuilding(id, page=1){
    //   let commandUri = this.getApiUri(this.apiBaseUri+"project/"+id+"/link-building", {page:page});
    //   return await Calls.call("GET", commandUri);
    // },
    async googleAccesTokenRetrieval(refresh_token){
      const commandUri = "https://oauth2.googleapis.com/token";
      let formData= {
        refresh_token: refresh_token,
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
        redirect_uri: window.location.origin,
        grant_type: "refresh_token"
      }
      return await Calls.callOutter("POST", commandUri, JSON.stringify(formData));
    },
    async googleRefreshToken(code){
      let commandUri = "https://oauth2.googleapis.com/token";
      let formData= {
        code: code,
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
        redirect_uri: window.location.origin,
        grant_type: "authorization_code"
      }
      return await Calls.callOutter("POST", commandUri, JSON.stringify(formData));
    },
    async fetchExternalSite(url){
      return await Calls.callOutter("GET", url, null, true);
    }
  };
  
  export default Calls;
  